export default __webpack_public_path__ + "static/media/DaoMaker-hover.c0fb8c2b.svg";